const hostName = window.location.host.startsWith("local") ? window.location.hostname + ":5000" : "api-dev.remotewoundcare.ca";
const protocol = window.location.host.startsWith("local") ? window.location.protocol : "https:"

export const apiBaseUrl = `${protocol}//${hostName}/api`;
export const publicApiBaseUrl = `${protocol}//${hostName}/public/api`;

console.debug("ApiConfigs - Private & public base url:", apiBaseUrl, publicApiBaseUrl);